import {errorSkeleton} from "../../error";

const reducer = (state, action) => ({
    ...state,
    loading: true,
    submitting: ['POST', 'PATCH', 'DELETE'].includes(action.payload.request.method)
});

const reducerSuccess = (state, action) => ({
    ...state,
    data: action.payload,
    error: errorSkeleton,
    initialized: true,
    loading: false,
    submitting: false,
    hasError: false
});

const reducerFail = (state, action) => ({
    ...state,
    error: action.error.response,
    loading: false,
    submitting: false,
    hasError: true
});

export const INITIAL_STATE = {
    loading: false,
    submitting: false,
    hasError: false,
    data: {},
    error: errorSkeleton,
    initialized: false
};

export default function () {
    return {
        INITIAL_STATE,
        reducer,
        reducerSuccess,
        reducerFail
    };
}


